import React from 'react';
import { Heading, Skeleton } from '@landr/maestro';

const Byline = ({
    isLoading,
    content,
}: {
    isLoading: boolean;
    content?: string;
}) => {
    if (isLoading) {
        return <Skeleton width="200px" height="20px" />;
    }

    return (
        <Heading
            as="h3"
            color="text.medium"
            textStyle="body"
            fontWeight="regular"
        >
            {content}
        </Heading>
    );
};

export default Byline;
